import { Navigate, Outlet } from "react-router-dom";

import { useOrganisationContext } from "@/lib/context/OrganisationProvider";

export const AdminGuard = (): JSX.Element | null => {
  const { isAdmin, isLoading } = useOrganisationContext();

  if (isLoading) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/user" replace />;
  }

  return <Outlet />;
};
